<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let label = ''
	export let checked = false

	const dispatch = createEventDispatcher()

	function click(e: any) {
		dispatch('click', {
			value: e.target.checked
		})
	}
</script>

<label>
  <input
  	type="checkbox"
		on:click={click}
		bind:checked={checked}
  >
 	<span class="ml-1">{label}</span>
</label>